import { Box, Button, Typography } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import "./translations";

import { Header } from "@/components";
import { saveLogoutReturnTo } from "@/helpers/logoutNavigationHelpers";

export const AccessDeniedPage = (): JSX.Element => {
  const { t } = useTranslation("AccessDeniedPage");
  const { oktaAuth } = useOktaAuth();

  const onLogoutClick = (): void => {
    saveLogoutReturnTo();
    oktaAuth.signOut();
  };

  return (
    <>
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 80px)",
          px: 2,
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", mb: 2 }} variant="body1">
          {t("message")}
        </Typography>
        <Typography sx={{ mb: 2 }} variant="body1">
          {t("description")}
        </Typography>
        <Typography sx={{ mb: 3 }} variant="body1">
          {t("details")}
        </Typography>
        <Button variant="contained" color="primary" onClick={onLogoutClick}>
          {t("buttonText")}
        </Button>
      </Box>
    </>
  );
};
